<template>
  <div class="courierStatus">
    <div class="icon"><img src="../../../../static/images/successIcon.png" alt=""></div>
    <template v-if="type == '1'">
    <div class="name">申请成功</div>
    <div class="tips">请等待管理员审核通过</div>
    </template>
    <template v-else-if="type == '2'">
    <div class="name">审核通过</div>
    <div class="tips">快递员信息已记录到后台</div>
    </template>
    <template v-else>
    <div class="name">审核不通过</div>
    <div class="tips">已短信通知该快递员拒绝原因</div>
    </template>
  </div>
</template>
<script>
import { showToast } from '../../../../static/js/utility/utility';
import axios from 'axios'
import * as config from '../../../../static/js/config.js';
export default {
  name:'courierStatus',
  data(){
    return{
      type:'',//1提交申请，2申请通过，3申请不通过
    }
  },
  methods:{

  },
  created(){
    this.type = this.$route.query.type
  },

}
</script>
<style lang="scss">
.courierStatus{
  text-align: center;
  height: 100vh;
  background-color: #f2f2f2;
  padding: 1rem 0;
  box-sizing: border-box;
  .icon{
    width: 2rem;
    height: 2rem;
    margin: 0 auto;
    img{ width: 100%;}
  }
  .name{
    margin: 0.2rem 0;
    font-size: 0.4rem;
  }
  .tips{
    font-size: 0.3rem;
    color: #999;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/PhonePage/courierBusiness/courierStatus.vue